export const channel = [
  // {
  //   id: 1,
  //   title: "Supported Social Channels",
  //   silver: "",
  //   gold: "",
  //   platinum: "",
  //   color: "#F4F5F9",
  // },
  // {
  //   id: 2,
  //   title: "Social Channels",
  //   silver: "12",
  //   gold: "36",
  //   platinum: "84",
  // },
  {
    id: 2,
    title: "Social Channels",
    silver: "15",
    gold: "40",
    platinum: "100",
  },
  {
    id: 3,
    title: "Users",
    silver: "3",
    gold: "15",
    platinum: "50",
  },

  {
    id: 5,
    title: "Mentions (Listen)",
    silver: "-",
    gold: "2000*",
    platinum: "10,000*",
  },
  // {
  //   id: 5,
  //   title: "Mentions",
  //   silver: "5000*",
  //   gold: "25000*",
  //   platinum: "100000*",
  // },
];
export const data = [
  {
    id: 6,
    title: "Publish",
    silver: "",
    gold: "",
    platinum: "",
    color: "#F4F5F9",
    bold: "bold",
  },
  {
    id: 7,
    title: "Posting Rich Media Content",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 8,
    title: "Bulk Media Upload",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 9,
    title: "Tagging",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 10,
    title: "Recall Post",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 11,
    title: "Global Time Zone Selection",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 12,
    title: "Audience Targeting	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 13,
    title: "Social Calendar	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 14,
    title: "Insta-Alerts via Email",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 15,
    title: "Create Content Instantly with Crello	",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 16,
    title: "FB Ad Manager",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 17,
    title: "URL Shortener	",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 18,
    title: "ORM - Omnibox & Respond	",
    silver: "",
    gold: "",
    platinum: "",
    color: "#F4F5F9",
    bold: "bold",
  },
  {
    id: 19,
    title: "Omni Social Channel + Email Inbox	",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 20,
    title: "Collaboration",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  // {
  //   id: 21,
  //   title:
  //     "Respond with Status – Open, Assigned, end, Soft end, In Progress, Ignore, Save as Draft	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  {
    id: 22,
    title: "In Mention Search	",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 23,
    title:
      "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest	",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  // {
  //   id: 24,
  //   title:
  //     "Respond with Status – Open, Assigned, end, Soft end, In Progress, Ignore, Save as Draft	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  {
    id: 25,
    title: "Export to XLS, PDF & Share via Email	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 26,
    title: "Listen",
    silver: "",
    gold: "",
    platinum: "",
    color: "#F4F5F9",
    bold: "bold",
  },
  {
    id: 27,
    title: "Keyword search across select social channels	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  // {
  //   id: 28,
  //   title:
  //     "Respond with Status – Open, Assigned, end, Soft end, In Progress, Ignore, Save as Draft	",
  //   silver: "close",
  //   gold: "open",
  //   platinum: "open",
  // },
  {
    id: 29,
    title: "Export to CSV, PDF",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  // {
  //   id: 30,
  //   title: "ORM - Omnibox & Respond	",
  //   silver: "",
  //   gold: "",
  //   platinum: "",
  //   color: "#F4F5F9",
  // },
  // {
  //   id: 31,
  //   title: "Omni Social Channel + Email Inbox	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  // {
  //   id: 32,
  //   title: "Collaboration",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  // {
  //   id: 33,
  //   title:
  //     "Respond with Status – Open, Assigned, end, Soft end, In Progress, Ignore, Save as Draft	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  // {
  //   id: 34,
  //   title: "In Mention Search	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  // {
  //   id: 35,
  //   title:
  //     "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest	",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  // {
  //   id: 36,
  //   title: "Export to XLS, PDF & Share via Email		",
  //   silver: "open",
  //   gold: "open",
  //   platinum: "open",
  // },
  {
    id: 37,
    title: "Reports & Analytics	",
    silver: "",
    gold: "",
    platinum: "",
    color: "#F4F5F9",
    bold: "bold",
  },
  {
    id: 38,
    title: "Unified Dashboard	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 39,
    title: "Social Channels Report	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 40,
    title: "Analytics",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 41,
    title: "Sentiment Analysis	",
    silver: "close",
    gold: "open",
    platinum: "open",
  },
  {
    id: 42,
    title: "Support - 24*7*365	",
    silver: "",
    gold: "",
    platinum: "",
    color: "#F4F5F9",
    bold: "bold",
  },
  {
    id: 43,
    title: "Email",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 44,
    title: "Call",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
  {
    id: 45,
    title: "Chat",
    silver: "open",
    gold: "open",
    platinum: "open",
  },
];
export const pricingFaq = [
  {
    id: 1,
    title: "What is CloudSocial?",
    content:
      "The CloudSocial is a cloud based platform allows you to manage your social media platforms seamlessly and efficiently. You can respond, analyse, listen and publish. Making sure that a single unified interface is available to you to manage and execute your social media strategy. In addition it also has email as a channel for a truly 360 degree experience.",
    table: [],
  },
  {
    id: 2,
    title: "Do you need my credit card for free trial?",
    content:
      "No, we don’t need your credit card details to start a 7-day free trial. However, once your free trial is completed, you will need to subscribe to one of our paid packs.",
    table: [],
  },
  {
    id: 3,
    title: "What kind of support do you provide?",
    content:
      "We take supporting you very seriously. Should you need any help in configuring or using CloudSocial we are there to support you. You can reach our support team through the Support Tab inside of CloudSocial. You can raise a ticket, chat or send us an email. We are open 24x7x365 days a year. This is across all our packs/plans.",
    table: [],
  },
  {
    id: 4,
    title: "Which is the best package according to my requirements?",
    content:
      "CloudSocial provides you with 3 different packages. You can select the pack which fits your requirements best.",
    table: [
      "If you are a small businessman or solopreneur then go for Silver,",
      "for Brands we recommend Gold,",
      "and Platinum for Social, Digital Agencies and Marketing Agencies.",
    ],
  },
  {
    id: 5,
    title: "Which all social profiles can be managed through CloudSocial?",
    content:
      "You can manage your Social Media presence across all these profiles:",
    table: [
      "Facebook Business Page",
      "Facebook Ad Manager",
      "Facebook Messenger",
      "Facebook Groups",
      "Facebook Profile",
      "Instagram Business Page",
      "Twitter Profile",
      "Twitter DM",
      "LinkedIn Business Page",
      "YouTube Channel Page",
      "Google My Business",
      "Email",
    ],
  },
];

export const silver = [
  "Social Channels: 15",
  // "Social Profiles: 1",
  "Users: 3",
  "Mentions (Listen): - ",
  "Posting Rich Media Content",
  "Bulk Media Upload",
  "Tagging",
  "Recall Post",
  "Global Time Zone Selection",
  // "Audience Targeting",
  "Create Content Instantly with Crello",
  "FB Ad Manager",
  "URL Shortener",
  "Omni Social Channel + Email Inbox",
  "Collaboration",
  "In Mention Search",
  "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest",
  "Email",
  "Call",
  "Chat",

  // "URL Shortener",
  // "Omni Social Channel + Email Inbox",
  // "Collaboration",
  // "Respond with Status – Open, Assigned, Close, Soft Close, In Progress, Ignore, Save as Draft",
  // "In Mention Search",
  // "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest",
  // "Keyword search across select social channels",
  // "Unified Dashboard",
  // "Social Channels Report",
];
const dataCross = ["Audience Targeting", "Social Calendar"];
export const gold = [
  "Social Channels: 40",
  // "Social Profiles: 3",
  "Users: 15",
  "Mentions (Listen): 2000*",
  "Posting Rich Media Content",
  "Bulk Media Upload",
  "Tagging",
  "Recall Post",
  "Global Time Zone Selection",
  "Audience Targeting",
  "Social Calendar",
  "Insta-Alerts via Email",
  "Create Content Instantly with Crello",
  "FB Ad Manager",
  "URL Shortener",
  "Omni Social Channel + Email Inbox",
  "Collaboration",
  "In Mention Search",
  "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest",
  "Export to XLS, PDF & Share via Email",
  "Keyword search across select social channels",
  "Export to CSV, PDF",
  "Unified Dashboard",
  "Social Channels Report",
  "Analytics",
  "Sentiment Analysis",
  "Email",
  "Call",
  "Chat",
];
export const platinum = [
  "Social Channels: 100",
  // "Social Profiles: 7",
  "Users: 50",
  "Mentions (Listen): 10,000*",
  // "Social Profiles: 1",
  "Posting Rich Media Content",
  "Bulk Media Upload",
  "Tagging",
  "Recall Post",
  "Global Time Zone Selection",
  "Audience Targeting",
  "Social Calendar",
  "Insta-Alerts via Email",
  "Create Content Instantly with Crello",
  "FB Ad Manager",
  "URL Shortener",
  "Omni Social Channel + Email Inbox",
  "Collaboration",
  "In Mention Search",
  "Filters – Date Range, Respond Status, Social Channel, Ticket Status, Sort by Oldest/Newest",
  "Export to XLS, PDF & Share via Email",
  "Keyword search across select social channels",
  "Export to CSV, PDF",
  "Unified Dashboard",
  "Social Channels Report",
  "Analytics",
  "Sentiment Analysis",
  "Email",
  "Call",
  "Chat",
];

export const silver1 = [
  "Audience Targeting",
  "Social Calendar",
  "Insta-Alerts via Email",
  "Export to XLS, PDF & Share via Email",
  "Keyword search across select social channels",
  "Export to CSV, PDF",
  "Unified Dashboard",
  "Social Channels Report",
  "Analytics",
  "Sentiment Analysis",
];
